import React from "react";
import {
  FaInstagram,
  FaFacebookF,
  FaYoutube,
  FaWhatsapp,
} from "react-icons/fa";
import { FiMapPin, FiPhone, FiMail } from "react-icons/fi";

const Footer = () => {
  return (
    <footer className="bg-black border-t border-white/10">
      <div className="mx-auto max-w-7xl px-6 py-16">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          {/* Logo */}
          <div>
            <h2 className="text-3xl font-semibold text-white">
              Studio<span className="text-amber-400">44</span>
            </h2>

            <p className="mt-4 text-sm leading-7 text-gray-400">
              Capturing timeless memories through creative photography and
              cinematic storytelling.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="mb-5 text-lg font-medium text-white">
              Quick Links
            </h3>

            <ul className="space-y-3 text-gray-400">
              <li>
                <a href="#home" className="hover:text-amber-400">
                  Home
                </a>
              </li>
              <li>
                <a href="#portfolio" className="hover:text-amber-400">
                  Portfolio
                </a>
              </li>
              <li>
                <a href="#booking" className="hover:text-amber-400">
                  Book Now
                </a>
              </li>
              <li>
                <a href="#contact" className="hover:text-amber-400">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="mb-5 text-lg font-medium text-white">
              Services
            </h3>

            <ul className="space-y-3 text-gray-400">
              <li>
                <a href="#services" className="hover:text-amber-400 transition">
                  Wedding
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-amber-400 transition">
                  Pre Wedding
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-amber-400 transition">
                  Baby Shower
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-amber-400 transition">
                  Birthday
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-amber-400 transition">
                  Events
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div id="contact">
            <h3 className="mb-5 text-lg font-medium text-white">
              Contact
            </h3>

            <div className="space-y-4 text-gray-400">
              <div className="flex items-center gap-3">
                <FiMapPin className="text-amber-400 shrink-0" size={18} />
                <span>Vellore, Tamil Nadu</span>
              </div>
              <div className="flex items-center gap-3">
                <FiPhone className="text-amber-400 shrink-0" size={18} />
                <a href="tel:+918248238436" className="hover:text-amber-400 transition">
                  +91 82482 38436
                </a>
              </div>
              <div className="flex items-center gap-3">
                <FiMail className="text-amber-400 shrink-0" size={18} />
                <a href="mailto:hello@studio44.com" className="hover:text-amber-400 transition">
                  hello@studio44.com
                </a>
              </div>
            </div>

            <div className="mt-6 flex gap-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/5 text-white transition-all duration-300 hover:border-amber-400 hover:bg-amber-400 hover:text-black hover:scale-110"
              >
                <FaInstagram size={18} />
              </a>

              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/5 text-white transition-all duration-300 hover:border-amber-400 hover:bg-amber-400 hover:text-black hover:scale-110"
              >
                <FaFacebookF size={18} />
              </a>

              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/5 text-white transition-all duration-300 hover:border-amber-400 hover:bg-amber-400 hover:text-black hover:scale-110"
              >
                <FaYoutube size={18} />
              </a>

              <a
                href="https://wa.me/918248238436"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/5 text-white transition-all duration-300 hover:border-amber-400 hover:bg-amber-400 hover:text-black hover:scale-110"
              >
                <FaWhatsapp size={18} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between border-t border-white/10 pt-6 text-sm text-gray-500 md:flex-row">
          <p>© 2026 Studio44. All Rights Reserved.</p>

          <p>
            Designed & Developed by{" "}
            <a href="https://optywize.com" target="_blank" rel="noopener noreferrer" className="text-amber-400 hover:underline font-bold transition">
              Optywize
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;